
webpack.register(
    'components/modal-dialog/modal-dialog',
    function() {
        return require('components/modal-dialog/modal-dialog');
    },
    false
);
webpack.register(
    'components/brightcove-video/brightcove-video',
    function() {
        return require('components/brightcove-video/brightcove-video');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/modal-dialog/modal-dialog'/>\r\n<can-import from='components/brightcove-video/brightcove-video'/>\r\n\r\n<modal-dialog video-id=\"{{videoId}}\" {active}=\"true\">\r\n    <brightcove-video\r\n        pause-on-exit-fullscreen=\"pauseOnExitFullscreen\"\r\n        (fullscreenchange)=\"onChangeFullscreen(%viewModel)\"\r\n        autoplay=\"true\"\r\n        {video-id}=\"videoId\"\r\n        {disable-pip}=\"true\"\r\n    />\r\n</modal-dialog>");